import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/material-person.png'


const _hoisted_1 = {
  key: 0,
  class: "dashboard py-5"
}
const _hoisted_2 = { class: "d-flex flex-lg-row flex-xl-row flex-column-reverse justify-xl-center mx-3 align-center" }
const _hoisted_3 = {
  key: 0,
  class: "column-1 mx-2"
}
const _hoisted_4 = { class: "mb-6 text-left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "column-1 mx-2"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "column-2 mx-2" }
const _hoisted_10 = { class: "d-flex justify-center" }
const _hoisted_11 = { class: "text-h6 text-center mb-1" }
const _hoisted_12 = { class: "ma-1 text-light" }
const _hoisted_13 = { class: "ma-1" }
const _hoisted_14 = { class: "d-flex flex-lg-row flex-xl-row flex-column justify-xl-center mx-2 align-center" }
const _hoisted_15 = {
  key: 0,
  class: "column-1 mx-2"
}
const _hoisted_16 = ["to"]
const _hoisted_17 = { class: "column-2 mx-2" }
const _hoisted_18 = { class: "mb-4 ml-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AveineSaleCharts = _resolveComponent("AveineSaleCharts")!
  const _component_AveineSaleDetails = _resolveComponent("AveineSaleDetails")!

  return (_ctx.$auth.ambassador && _ctx.$auth.ambassador.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.invoiceSummary['amount-unlocked-euro'] || _ctx.invoiceSummary['amount-unlocked-dollar'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_card, { class: "rounded-lg promotional-banner py-16 px-6 pb-4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("aveine-space.title.declareRevenue")), 1),
                    (_ctx.invoiceSummary['amount-unlocked-euro'] || _ctx.invoiceSummary['amount-unlocked-dollar'])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("aveine-space.sales.unlockedMoney")), 1),
                          _createTextVNode(),
                          _hoisted_6,
                          _createTextVNode(),
                          _createElementVNode("h1", null, _toDisplayString(_ctx.invoiceSummary["amount-unlocked-euro"] ? _ctx.invoiceSummary["amount-unlocked-euro"] + " EUR" : _ctx.invoiceSummary["amount-unlocked-dollar"] + " USD"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      class: "my-5",
                      "rounded-lg": "",
                      color: "primary",
                      variant: "flat",
                      to: { name:'InvoiceCreate', params: {id: _ctx.$auth.ambassador.id} }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.title.declare")), 1)
                      ], undefined, true),
                      _: 1
                    }, 8, ["to"])
                  ], undefined, true),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.$auth.ambassador)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 0,
                      class: "rounded-lg promotional-banner py-16 px-6 pb-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", {
                          innerHTML: _ctx.$t('aveine-space.title.websitePromo'),
                          class: "mb-4 mt-16 text-left",
                          style: {"color":"#ffffff"}
                        }, null, 8, _hoisted_8),
                        _createVNode(_component_v_btn, {
                          class: "ma-1 mb-5",
                          "rounded-sm": "",
                          href: "https://aveine.com/",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.title.accessWebsite")), 1)
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.$auth.ambassador)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "py-6 px-14 rounded-lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        rounded: "",
                        class: "ma-6",
                        size: "100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, { src: _imports_0 })
                        ], undefined, true),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$auth.ambassador.name), 1),
                      _createVNode(_component_v_col, { class: "discount-code d-flex flex-column align-center mt-4" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("aveine-space.sales.discountCode")), 1),
                          _createTextVNode(),
                          _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$auth.ambassador.promotion_code), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.$vuetify.display.name == 'xl' || _ctx.$vuetify.display.name == 'lg')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_v_card, { class: "d-flex pa-6 px-xl-14 px-lg-12 rounded-lg chart-container" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", {
                      class: "mb-5",
                      to: { name:'AmbassadorSales', params: {id: _ctx.$auth.ambassador.id} }
                    }, [
                      _createVNode(_component_router_link, {
                        style: {},
                        to: { name:'AmbassadorSales', params: {id: _ctx.$auth.ambassador.id} }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.title.page.mySales")), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["to"])
                    ], 8, _hoisted_16),
                    _createVNode(_component_AveineSaleCharts, {
                      class: "component",
                      dashboardActions: true,
                      presentationMode: true,
                      ambassadorId: _ctx.$auth.ambassador.id,
                      discountCode: _ctx.$auth.ambassador.promotion_code,
                      selectedCurrency: _ctx.selectedCurrency
                    }, null, 8, ["ambassadorId", "discountCode", "selectedCurrency"])
                  ], undefined, true),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_card, { class: "sale-details rounded-lg text-left align-start" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: { name:'AmbassadorSales', params: {id: _ctx.$auth.ambassador.id} }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.dashboard.ambassadorSales")), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createVNode(_component_AveineSaleDetails, {
                  class: "component",
                  summaryMode: true,
                  selectedCurrency: _ctx.selectedCurrency,
                  monthSalesNumber: _ctx.monthSalesNumber,
                  yearSalesNumber: _ctx.yearSalesNumber,
                  totalSalesNumber: _ctx.totalSalesNumber,
                  totalIncome: _ctx.totalIncome,
                  pendingIncome: _ctx.pendingIncome,
                  adminMode: true
                }, null, 8, ["selectedCurrency", "monthSalesNumber", "yearSalesNumber", "totalSalesNumber", "totalIncome", "pendingIncome"])
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}